import {ITEM_ROUTES as itemRoutes} from "~/api/routes";

export const state = () => ({
  items: null
});
export const getters = {};
export const mutations = {
  ITEM_PROCESSING_START(state) {
    //state.isLoading = false;
  },
  ITEM_ERROR(state) {
    //state.isLoading = false;
  },
  ITEM_PROCESSING_END(state) {
    //state.isLoading = false;
  },
};
export const actions = {
  async delete({commit}, params) {
    commit('ITEM_PROCESSING_START');
    await this.$api.request(itemRoutes.delete, {},params)
      .then(response => {
        //commit('', params);
        const nextRequest = params.nextRequest;
        this.dispatch(nextRequest.action,nextRequest.params);
      })
      .catch(error => {
        commit('ITEM_ERROR');
      })
      .finally(() => commit('ITEM_PROCESSING_END'));
  }
};
